
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, AuthService, CdrUnitOfWork, UtilityService } from 'src/app/core/core.module';
import { Rental } from 'src/app/core/model/rental';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';
import { DialogService } from 'src/app/shared/dialog.service';

@Component({
    selector: 'app-job-time-dialog',
    standalone: true,
    templateUrl: './customer-rentals-dialog.component.html',
    styleUrls: ['./customer-rentals-dialog.component.scss'],
    imports: [RouterModule, DevExtremeModule]
})
export class CustomerRentalsDialogComponent extends BaseDialogComponent<any> implements OnInit {
    customerId: number;
    startDate: Date;
    endDate: Date;
    rentals: any[];

    constructor(
        private uow: CdrUnitOfWork,
        private router: Router,
        private appInfo: AppInformationService,
    ) {
        super();
    }

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.rentals = await this.uow.rentals.getRentalsByCustomer(this.customerId, this.startDate, this.endDate, true);
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            }
        );
    }

    open(rental?: Rental) {
        if (!rental) return;
        this.hide();
        this.router.navigate([`/rentals/${rental.id}`]);
    }
}
